import classes from "./FooterSection.module.css";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import { IconContext } from "react-icons";

const FooterSection = () => {
  const iconsStyles = {
    size: "1.5rem",
  };
  const actualYear = new Date();
  return (
    <IconContext.Provider value={iconsStyles}>
      <div className={classes.main_container}>
        <div className={classes.content_container}>
          <div className={classes.icons_container}>
            <a
              href="https://www.linkedin.com/in/oscar-castroin10/"
              target="_blank"
              className={classes.linkedinicon}
            >
              <BsLinkedin />
            </a>
            <a
              href="https://github.com/alejandro-saav?tab=repositories"
              target="_blank"
              className={classes.githubicon}
            >
              <BsGithub />
            </a>
          </div>
          <h1 className={classes.text}>Oscar Castro</h1>
          <h4 className={classes.text}>Portfolio</h4>
          <h4 className={classes.text}>&copy; {actualYear.getFullYear()}</h4>
        </div>
      </div>
    </IconContext.Provider>
  );
};

export default FooterSection;
